define( function() {
	return ( /^$|\/(?:java|ecma)script/i );
} );



// WEBPACK FOOTER //
// ./~/jquery/src/manipulation/var/rscriptType.js